// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../layers/google.nodejs.yarn/yarn_modules/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../layers/google.nodejs.yarn/yarn_modules/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../layers/google.nodejs.yarn/yarn_modules/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/img/backgrounds/Background.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./rs2_big.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

body {
  background-color: #c48ad61f !important;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

@media (max-width: 767px) {
  .custom-padding {
    padding-left: 0 !important;
  }
}

@media (min-width: 768px) {
  .custom-padding {
    padding-left: 18rem !important;
    /* This is equivalent to ps-72 */
  }
}



.adminManiBackground {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.adminImgae {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

/* for sidebar */
/* Custom sidebar transition */
.sidebar-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1040;
  /* Ensure it's below the sidebar but above other content */
}

.show-sidebar {
  transform: translateX(0%);
  transition: transform 0.3s ease-out;
}

.offcanvas-hidden {
  transform: translateX(-100%);
  transition: transform 0.3s ease-in;
}

@media (min-width: 768px) {
  .layout-menu {
    transform: none !important;
  }
}

::-webkit-scrollbar {
  width: 9px;
}

::-webkit-scrollbar-thumb {
  background: linear-gradient(180deg, #4C264F, #e470a0);
  /* Gradient thumb */
  border-radius: 10px;
}

::-webkit-scrollbar-track {
  background: #F7F0FA;
  /* Track color */
}
.custom-tooltip + .tooltip > .tooltip-inner {
  background-color: #6f42c1; /* Background color (shade of purple) */
  color: #fff; /* Text color */
  border-radius: 5px; /* Rounded corners */
  font-size: 14px; /* Font size */
  padding: 10px; /* Padding */
}

.custom-tooltip + .tooltip > .tooltip-arrow {
  border-top-color: #6f42c1; /* Arrow color (same shade of purple) */
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,8BAA8B;IAC9B,gCAAgC;EAClC;AACF;;;;AAIA;EACE,yDAAgE;EAChE,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,yDAAsC;EACtC,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA,gBAAgB;AAChB,8BAA8B;AAC9B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,0DAA0D;AAC5D;;AAEA;EACE,yBAAyB;EACzB,mCAAmC;AACrC;;AAEA;EACE,4BAA4B;EAC5B,kCAAkC;AACpC;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qDAAqD;EACrD,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,yBAAyB,EAAE,uCAAuC;EAClE,WAAW,EAAE,eAAe;EAC5B,kBAAkB,EAAE,oBAAoB;EACxC,eAAe,EAAE,cAAc;EAC/B,aAAa,EAAE,YAAY;AAC7B;;AAEA;EACE,yBAAyB,EAAE,uCAAuC;AACpE","sourcesContent":[".App {\r\n  text-align: center;\r\n}\r\n\r\nbody {\r\n  background-color: #c48ad61f !important;\r\n}\r\n\r\n.App-logo {\r\n  height: 40vmin;\r\n  pointer-events: none;\r\n}\r\n\r\n@media (prefers-reduced-motion: no-preference) {\r\n  .App-logo {\r\n    animation: App-logo-spin infinite 20s linear;\r\n  }\r\n}\r\n\r\n@media (max-width: 767px) {\r\n  .custom-padding {\r\n    padding-left: 0 !important;\r\n  }\r\n}\r\n\r\n@media (min-width: 768px) {\r\n  .custom-padding {\r\n    padding-left: 18rem !important;\r\n    /* This is equivalent to ps-72 */\r\n  }\r\n}\r\n\r\n\r\n\r\n.adminManiBackground {\r\n  background-image: url('./assets/img/backgrounds/Background.svg');\r\n  background-size: cover;\r\n  background-position: center;\r\n  background-repeat: no-repeat;\r\n}\r\n\r\n.adminImgae {\r\n  background-image: url('./rs2_big.png');\r\n  background-size: cover;\r\n  background-position: center;\r\n  background-repeat: no-repeat;\r\n}\r\n\r\n.App-header {\r\n  background-color: #282c34;\r\n  min-height: 100vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: calc(10px + 2vmin);\r\n  color: white;\r\n}\r\n\r\n.App-link {\r\n  color: #61dafb;\r\n}\r\n\r\n@keyframes App-logo-spin {\r\n  from {\r\n    transform: rotate(0deg);\r\n  }\r\n\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n/* for sidebar */\r\n/* Custom sidebar transition */\r\n.sidebar-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background-color: rgba(0, 0, 0, 0.5);\r\n  z-index: 1040;\r\n  /* Ensure it's below the sidebar but above other content */\r\n}\r\n\r\n.show-sidebar {\r\n  transform: translateX(0%);\r\n  transition: transform 0.3s ease-out;\r\n}\r\n\r\n.offcanvas-hidden {\r\n  transform: translateX(-100%);\r\n  transition: transform 0.3s ease-in;\r\n}\r\n\r\n@media (min-width: 768px) {\r\n  .layout-menu {\r\n    transform: none !important;\r\n  }\r\n}\r\n\r\n::-webkit-scrollbar {\r\n  width: 9px;\r\n}\r\n\r\n::-webkit-scrollbar-thumb {\r\n  background: linear-gradient(180deg, #4C264F, #e470a0);\r\n  /* Gradient thumb */\r\n  border-radius: 10px;\r\n}\r\n\r\n::-webkit-scrollbar-track {\r\n  background: #F7F0FA;\r\n  /* Track color */\r\n}\r\n.custom-tooltip + .tooltip > .tooltip-inner {\r\n  background-color: #6f42c1; /* Background color (shade of purple) */\r\n  color: #fff; /* Text color */\r\n  border-radius: 5px; /* Rounded corners */\r\n  font-size: 14px; /* Font size */\r\n  padding: 10px; /* Padding */\r\n}\r\n\r\n.custom-tooltip + .tooltip > .tooltip-arrow {\r\n  border-top-color: #6f42c1; /* Arrow color (same shade of purple) */\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
